import { render, staticRenderFns } from "./UnitsAndRules.vue?vue&type=template&id=068d5d6a&scoped=true"
import script from "./UnitsAndRules.vue?vue&type=script&lang=js"
export * from "./UnitsAndRules.vue?vue&type=script&lang=js"
import style0 from "./UnitsAndRules.vue?vue&type=style&index=0&id=068d5d6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "068d5d6a",
  null
  
)

export default component.exports